import React, { useState, useEffect, useRef } from "react";
import { useUser } from "~/Context/userContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "@dreamchimney/react-axios";
import styled from "styled-components";
import Spinner from "react-bootstrap/Spinner";

import { LOCAL_STORE_JWT } from "~/utils/main";
import { validate } from "./SubmitValidationRules";
import useSubmitForm from "./useSubmitForm";
import TagSelection from "./TagSelection";
import { getTagsAsArray, removeDuplicates } from "../../Global/TagsUtil";
import { apiConfig } from "~/api/apiConfig";

export const Wrapper = styled.section`
  margin: 10px 0 0 0;
`;

const SubmitForm = ({ onPreview }) => {
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(false); // the user
  const [tags, setTags] = useState([]);
  const tagTextAreaRef = useRef();

  // Bookmarklet
  const urlParams = new URLSearchParams(window.location.search);
  const queryParamLinkUrl = urlParams.get("urlLink") || null;
  const queryParamLinkText = urlParams.get("text") || null;

  const initialFormValues = {
    link_url: queryParamLinkUrl,
    otd_text: queryParamLinkText,
    // otd_title: "Hello",
    // otd_text: "Something random here",
    // link_url: "https://www.youtube.com/watch?v=36F6om_tJyM&ab_channel=MarvelEntertainment",
  };

  const options = {
    maxFiles: 1,
    accept: ["image/*"],
    onUploadDone: ({ filesUploaded = [], filesFailed = [] }) => {
      console.log("🚀 ~ file: SubmitForm.js ~ line 43 ~ SubmitForm ~ filesFailed", filesFailed);

      console.log("🚀 ~ file: SubmitPage.js ~ line 36 ~ SubmitPage ~ filesUploaded", filesUploaded);
      const firstUpload = filesUploaded[0] || {};
      console.log("🚀 ~ file: SubmitPage.js ~ line 40 ~ SubmitPage ~ firstUpload", firstUpload);
      if (firstUpload.url) {
        console.log("🚀 ~ file: SubmitPage.js ~ line 40 ~ SubmitPage ~ url", firstUpload.url);
        uploadedFileUrl(firstUpload.url);
      }

      // notes
      // source : "facebook"
      // status: "Stored"
      // If you throw any error in this function it will reject the file selection.
      // The error message will be displayed to the user as an alert.
      // Add banner after success or for error
    },
  };

  // useEffect(() => {
  // }, []);

  const openFileUploader = () => {
    const client = window.filestack.init(`AF7wxCxOKT5G7V4NcLF7qz`);
    client.picker(options).open();
  };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const tagSearch = async ({ target }) => {
    // split the text by comma, then use the last element
    // const terms = target.value.split(/[\s,]+/);
    const terms = target.value.split(/[,]+/);
    const term = terms[terms.length - 1].trim();
    const {
      data: { tags: tagResults },
    } = await axios.get(`${apiConfig.oftheday.tags.search}?terms=${term}`);
    setTags([...tagResults]);
  };

  const selectTag = (tag) => {
    const updatedTags = getTagsAsArray(inputs.tagsStr).slice(0, -1);
    updatedTags.push(tag);

    const tags = removeDuplicates(updatedTags);

    inputs.tagsStr = tags.join(",") + `,`; // add tag string back to textarea

    setTags([]); // clear search results
    tagTextAreaRef.current.focus();
  };

  const clickPreview = () => {
    const tagsToArray = getTagsAsArray(inputs.tagsStr);
    const tags = removeDuplicates(tagsToArray);
    inputs.tagsStr = tags.join(",") + `,`; // add tag string back to textarea

    // create mocked tags array objs just for preview
    const tagsForPreview = tags.map((item, i) => {
      return {
        tag_id: i,
        tag: item,
        total: "1",
      };
    });

    // Tags will show with undefined urls but displays ok
    const previewPayload = {
      cmt_count: 0,
      chim_full_name: userState.user.full_name,
      chim_dir: userState.user.dir,
      tags: tagsForPreview,
      ...inputs,
    };

    const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;

    const tagsFinal = tagsToArray.map((item) => ({
      tag: item,
    }));

    const finalPayload = {
      jwt,
      chim_dir: userState.user.dir,
      tags: tagsFinal,
      ...inputs,
    };

    onPreview(previewPayload, finalPayload);
  };

  const postSubmitAction = () => console.log("no-op");

  const { inputs, handleInputChange, uploadedFileUrl, handlePreview, errors } = useSubmitForm(
    initialFormValues,
    postSubmitAction,
    validate
  );
  if (loading) {
    return (
      <div>
        <Spinner animation="border" size="sm" /> Loading
      </div>
    );
  }
  return (
    <Wrapper className="SubmitFormWrapper">
      <Form className="totd-form totd-form-horizontal Submit-form" noValidate>
        <Row>
          <Col xs={12} md={{ span: 10, offset: 0 }}>
            <Form.Group as={Row} className={errors.otd_title ? "error" : ""}>
              <Col xs={12} md={{ span: 9, offset: 0 }}>
                <div className="otdTitleInputWrapper">
                  “
                  <Form.Control
                    name="otd_title"
                    onChange={handleInputChange}
                    value={inputs.otd_title || ""}
                    type="text"
                    autoComplete="off"
                    required
                  />
                  ” Of The Day
                </div>
                {errors.otd_title && <span className="help error">{errors.otd_title}</span>}
              </Col>
            </Form.Group>
          </Col>
          <Col xs={12} className="">
            <Form.Group as={Row} className={errors.otd_text ? "error" : ""}>
              <Col xs={12} md={{ span: 9, offset: 0 }}>
                <div>
                  Add any extra text about this
                  <Form.Control
                    name="otd_text"
                    onChange={handleInputChange}
                    value={inputs.otd_text || ""}
                    as="textarea"
                    rows="6"
                    autoComplete="off"
                    required
                  />
                  {errors.otd_text && <span className="help error">{errors.otd_text}</span>}
                </div>
              </Col>
            </Form.Group>
          </Col>
          <Col xs={12}>
            <div className="highlightSection">
              <Col xs={12} className="">
                <Form.Group as={Row} className={errors.tagsStr ? "error" : ""}>
                  <Col xs={12} className="highlightRow">
                    <div>
                      <strong>File Under:</strong>
                      <div className="instructions">
                        Enter tags separated with commas or just start typing below. Find existing tags while you type and click the tag
                        below it to insert!
                      </div>

                      {errors.tagsStr && <span className="help error">{errors.tagsStr}</span>}
                    </div>
                  </Col>
                  <Col xs={12} md={{ span: 10, offset: 0 }} className="highlightRow">
                    <Form.Control
                      name="tagsStr"
                      ref={tagTextAreaRef}
                      onChange={(e) => {
                        tagSearch(e);
                        return handleInputChange(e);
                      }}
                      value={inputs.tagsStr || ""}
                      as="textarea"
                      rows="2"
                      autoComplete="off"
                      required
                    />
                    <div className="instructions">* Type tag names above, they will appear here. Click tag name to add.</div>

                    <TagSelection
                      tags={tags}
                      selectTag={(tag) => {
                        if (tag && tag.tag) {
                          selectTag(tag.tag);
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </div>
          </Col>

          <Col xs={12}>
            <div className="highlightSection">
              <Col xs={12} className="">
                <div style={{ marginBottom: "20px", color: "#000" }}>
                  <strong>Upload or enter an Image URL:</strong>
                </div>
              </Col>

              <Col xs={12} className="">
                <Form.Group as={Row} className={errors.img_url ? "error" : ""}>
                  <Col xs={12} md={10} className="highlightRow">
                    <div className="inputFullWidth">
                      <div>
                        <img src="//dreamchimney.com/oftheday/images/linkUrlThumb.gif" alt="" />{" "}
                        <strong>
                          Image URL{" "}
                          {/* 
                          or{" "}
                          <span className="imageUploadButton" onClick={() => openFileUploader()}>
                            upload an image
                          </span>{" "}
                           */}
                        </strong>
                        <span className="help">(*Optional)</span>
                      </div>
                      <Form.Control
                        name="img_url"
                        onChange={handleInputChange}
                        value={inputs.img_url || ""}
                        type="text"
                        autoComplete="off"
                        required
                      />

                      {errors.img_url && <span className="help error">{errors.img_url}</span>}
                    </div>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} className="">
                <div style={{ marginBottom: "15px", color: "#000" }}>
                  <strong>Enter a web page URL:</strong>
                </div>
              </Col>

              <Col xs={12}>
                <Form.Group as={Row} className={errors.link_url ? "error" : ""}>
                  <Col xs={12} md={10} className="highlightRow">
                    <div className="inputFullWidth">
                      <div>
                        <img src="//dreamchimney.com/oftheday/images/imgUrlThumb.gif" alt="" /> <strong>URL</strong>{" "}
                        <span className="help">(ex: http://somefunnysite.com/funny_page.html)</span>
                      </div>
                      <Form.Control
                        name="link_url"
                        onChange={handleInputChange}
                        value={inputs.link_url || ""}
                        type="text"
                        autoComplete="off"
                        required
                      />

                      {errors.link_url && <span className="help error">{errors.link_url}</span>}
                    </div>
                  </Col>
                </Form.Group>
              </Col>
            </div>
          </Col>

          <Col xs={12} className="highlightRow">
            <Button
              variant="warning"
              className="btn-warning"
              onClick={() => {
                const hasErrors = handlePreview();
                if (!hasErrors) {
                  clickPreview();
                }
              }}
            >
              Preview
            </Button>
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default SubmitForm;
